import React, { useState, useEffect, useRef } from "react";
import FolderIcon from "./img/folder.webp";
import FolderSVGIcon from "./img/folderIcon.svg";
import { Button, Form, Row, Col, Modal, Alert } from "react-bootstrap";
import { useConfig } from "./ConfigContext";
export default function SharepointExplorer({
   label,
   buttonClassName,
   hideOnSelect,
   sharepointObject,
   loadSharepointData,
   selectedFiles,
   handleFileSelect,
   handleFolderSelect,
}) {
   const config = useConfig();
   const [freigeben, setFreigeben] = useState();
   const [show, setShow] = useState(false);
   const [expandedFolder, setExpandedFolder] = useState();
   const [layeredSharepointObject, setLayeredSharepointObject] = useState([]);

   const optionsRef = useRef(null);

   useEffect(() => {
      function handleClickOutside(event) {
         if (optionsRef.current && !optionsRef.current.contains(event.target)) {
            console.log("Außerhalb geklickt!");
            setShow(false);
         }
      }
      function handleWindowBlur() {
         // setShow(false);
      }
      // Den Listener hinzufügen
      document.addEventListener("mousedown", handleClickOutside);
      window.addEventListener("blur", handleWindowBlur);

      // WICHTIG: Den Listener beim Unmount entfernen (Cleanup)
      return () => {
         document.removeEventListener("mousedown", handleClickOutside);
         window.removeEventListener("blur", handleWindowBlur);
      };
   }, []);

   useEffect(() => {
      if (sharepointObject) {
         const newLayeredList = structuredClone(sharepointObject);
         Object.keys(newLayeredList).forEach((item) => {
            if (sharepointObject[item].parentFolder && newLayeredList[sharepointObject?.[item]?.parentReference?.id]) {
               newLayeredList[sharepointObject[item].parentReference.id]["children"] = {
                  ...(newLayeredList[sharepointObject[item].parentReference.id]?.["children"] ?? {}),
                  [item]: sharepointObject[item],
               };
               delete newLayeredList[item];
            }
         });
         setLayeredSharepointObject(newLayeredList);
      }
   }, [sharepointObject]);

   return (
      <>
         {!show && (
            <Button
               variant="outline-secondary"
               style={{borderColor: "#ddd"}}
               className={buttonClassName}
               // style={{ width: "200px" }}
               onClick={() => setShow(true)}
            >
               {label}
            </Button>
         )}

         {show && (
            <div
               ref={optionsRef}
               style={{
                  position: "absolute",
                  zIndex: 1,
                  padding: 10,
                  marginTop: "40px",
                  borderRadius: 10,
                  boxShadow: "0 0 10px #0003",
                  background: "#fff",
                  maxHeight: "500px",
                  overflow: "auto",
                  width: "100%",
               }}
            >
               <div>
                  {layeredSharepointObject && (
                     <>
                        <h4>Sharepoint-Ordner</h4>
                        <Button
                           title="Wenn eine Datei neu in den Sharepoint geladen wurde und noch nicht in der Liste auftaucht hier klicken um zu aktualisieren."
                           onClick={() => loadSharepointData()}
                           variant="outline-secondary"
                           className="ms-1"
                        >
                           ⟳
                        </Button>
                        <ul className="filelist">
                           {Object.keys(layeredSharepointObject).map((item) => {
                              const isFolder = layeredSharepointObject[item].folder;
                              if (layeredSharepointObject[item]) {
                                 return (
                                    <>
                                       <li
                                          className="file-explorer-item"
                                          key={"splist_" + layeredSharepointObject[item].id}
                                          style={{
                                             ...(selectedFiles[item]
                                                ? { backgroundColor: "#224b", color: "#fff" }
                                                : {}),
                                          }}
                                          onClick={() => {
                                             if (isFolder) {
                                                if (handleFolderSelect) {
                                                   handleFolderSelect(item);
                                                }
                                             } else {
                                                handleFileSelect(item);
                                             }
                                             if (hideOnSelect) setShow(false);
                                          }}
                                       >
                                          <div className="file-explorer-thumbnail">
                                             <img src={layeredSharepointObject[item]?.thumbnails?.[0]?.medium?.url} />
                                          </div>

                                          <div style={{ height: "42px" }}>
                                             <span>
                                                {isFolder && <img src={FolderSVGIcon} height="22" alt=" 🗁 " />}

                                                {layeredSharepointObject[item].name}
                                             </span>
                                             {isFolder && (
                                                <Button
                                                   style={{ position: "absolute", right: 10 }}
                                                   variant="dark"
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      setExpandedFolder((prev) => (item === prev ? false : item));
                                                   }}
                                                >
                                                   Ordner {expandedFolder === item ? "schließen" : "öffnen"}
                                                </Button>
                                             )}
                                          </div>

                                          {layeredSharepointObject[item].children && expandedFolder === item && (
                                             <ul
                                                style={{
                                                   boxShadow: "inset 0 0px 10px #2244",
                                                   borderRadius: "8px",
                                                }}
                                             >
                                                <li
                                                   style={{
                                                      display: "flex",
                                                      flexDirection: "row",
                                                      justifyContent: "space-between",
                                                      ...(selectedFiles[item]
                                                         ? { backgroundColor: "#224b", color: "#fff" }
                                                         : {}),
                                                   }}
                                                >
                                                   <div style={{ height: "42px" }}>
                                                      <span>
                                                         <img src={FolderSVGIcon} height="22" alt=" 🗁 " />
                                                         {layeredSharepointObject[item].name}
                                                      </span>
                                                   </div>
                                                </li>
                                                {Object.keys(layeredSharepointObject[item].children).map(
                                                   (childitem) => {
                                                      const isFolder2 =
                                                         layeredSharepointObject[item].children[childitem].folder;
                                                      console.log(layeredSharepointObject[item].children[childitem]);

                                                      return (
                                                         <li
                                                            className="file-explorer-item"
                                                            key={
                                                               "splist2_" +
                                                               layeredSharepointObject[item].children[childitem].id
                                                            }
                                                            style={{
                                                               ...(selectedFiles[childitem]
                                                                  ? { backgroundColor: "#224b", color: "#fff" }
                                                                  : {}),
                                                            }}
                                                            onClick={() => {
                                                               if (isFolder2) {
                                                                  if (handleFolderSelect) {
                                                                     handleFolderSelect(childitem);
                                                                  }
                                                               } else {
                                                                  handleFileSelect(childitem);
                                                               }
                                                               if (hideOnSelect) setShow(false);
                                                            }}
                                                         >
                                                            <div className="file-explorer-thumbnail">
                                                               <img
                                                                  src={
                                                                     layeredSharepointObject[item].children[childitem]
                                                                        ?.thumbnails?.[0]?.medium?.url
                                                                  }
                                                               />
                                                            </div>
                                                            <div style={{ height: "42px" }}>
                                                               <span>
                                                                  {isFolder2 && (
                                                                     <img src={FolderSVGIcon} height="22" alt=" 🗁 " />
                                                                  )}

                                                                  {
                                                                     layeredSharepointObject[item].children[childitem]
                                                                        .name
                                                                  }
                                                               </span>
                                                            </div>
                                                         </li>
                                                      );
                                                   },
                                                )}
                                             </ul>
                                          )}
                                       </li>
                                    </>
                                 );
                              }
                           })}
                        </ul>
                     </>
                  )}
               </div>

               <Button
                  className="mx-1"
                  variant="primary"
                  // style={{ width: "200px" }}
                  onClick={() => setShow(false)}
               >
                  Schließen
               </Button>
            </div>
         )}
      </>
   );
}
